const data = {
  email: 'personalproperty@utahcounty.gov',
  phone: '801-851-8295',
  street: '100 East Center',
  room: 'Room 1100',
  city: 'Provo',
  state: 'Utah',
  zip: '84606',
  hours: `Monday - Friday: 8 AM to 5 PM`,
  contactName: 'Burt Garfield',
  title: 'Assessor',
};

export default data;
